class SybilScrollHint extends HTMLElement {
  #controller;
  #dismissed = false;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const scroller = this.firstElementChild;
    if (!scroller) return;

    scroller.addEventListener('scroll', this.#dismiss, {
      once: true,
      passive: true,
      signal: this.#controller.signal,
    });
    window.addEventListener('resize', this.#update, {
      passive: true,
      signal: this.#controller.signal,
    });
    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #update = () => {
    const scroller = this.firstElementChild;
    if (!scroller) return;
    const overflows = scroller.scrollWidth > scroller.clientWidth;
    this.classList.toggle('has-overflow', overflows && !this.#dismissed);
  };

  #dismiss = () => {
    this.#dismissed = true;
    this.classList.remove('has-overflow');
  };
}

if (!customElements.get('sybil-scroll-hint')) {
  customElements.define('sybil-scroll-hint', SybilScrollHint);
}
